'use client';
import { jsx } from 'react/jsx-runtime';
import { useMenuTrigger } from '@react-aria/menu';
import { useMenuTriggerState } from '@react-stately/menu';
import { useTreeState } from '@react-stately/tree';
import { useRef, useMemo } from 'react';
import { HEIGHT_OF_OPTIONS_TO_SHOW } from '../listbox/listbox.context.js';
import { useMenuList, SwanMenuListContext } from './menu-list.context.js';
import { useModeExtractor } from '../../hooks/use-mode-extractor/index.js';
import { SwanMenuTriggerContext } from './menu-trigger.context.js';
import { useCollectionContext } from '../../contexts/internal/collection/collection.context.js';
import { SwanPopoverContextProvider, useSwanPopover } from '../popover/popover.context.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)t = c[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)t = c[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
function SwanMenuContextProviderInner(t) {
    let { children: i, onAction: s } = t, { triggerRef: b, triggerProps: f, overlayState: _ } = useSwanPopover(), { menuTriggerProps: y, menuProps: j } = useMenuTrigger(_object_spread_props(_object_spread({}, f), {
        type: 'menu'
    }), _, b), O = useMemo(()=>({
            triggerProps: y,
            triggerDisabled: false
        }), [
        y
    ]), d = useRef(null), { childItems: g, items: P, disabledKeys: w } = useCollectionContext(), v = useTreeState(_object_spread_props(_object_spread({}, j), {
        items: P,
        disabledKeys: w,
        children: g
    })), h = useMenuList(_object_spread_props(_object_spread({}, j), {
        onAction: s
    }), d, v);
    return jsx(SwanMenuTriggerContext.Provider, {
        value: O,
        children: jsx(SwanMenuListContext.Provider, {
            value: h,
            children: i
        })
    });
}
function SwanMenuContextProvider(r) {
    let { maxHeight: o } = r, p = _object_without_properties(r, [
        "maxHeight"
    ]), l = useMenuTriggerState({}), u = useRef(null), a = useRef(null), m = useModeExtractor(a, l.isOpen);
    return jsx(SwanPopoverContextProvider, {
        value: useMemo(()=>({
                popoverRef: u,
                triggerRef: a,
                overlayState: l,
                overlayProps: {},
                triggerProps: {},
                modes: m,
                maxHeight: null != o ? o : HEIGHT_OF_OPTIONS_TO_SHOW
            }), [
            u,
            a,
            l,
            m,
            o
        ]),
        children: jsx(SwanMenuContextProviderInner, _object_spread({}, p))
    });
}

export { SwanMenuContextProvider };
